import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const DragAndDropIcon = (props: SvgProps) => (
  <svg
    height="20"
    width="20"
    fill="none"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <path
      d="M7.91665 4.16667C7.91665 5.08712 7.17044 5.83333 6.24998 5.83333C5.32952 5.83333 4.58331 5.08712 4.58331 4.16667C4.58331 3.24619 5.32952 2.5 6.24998 2.5C7.17044 2.5 7.91665 3.24619 7.91665 4.16667ZM6.24998 11.6667C7.17044 11.6667 7.91665 10.9205 7.91665 10C7.91665 9.07954 7.17044 8.33333 6.24998 8.33333C5.32952 8.33333 4.58331 9.07954 4.58331 10C4.58331 10.9205 5.32952 11.6667 6.24998 11.6667ZM6.24998 17.5C7.17044 17.5 7.91665 16.7538 7.91665 15.8333C7.91665 14.9129 7.17044 14.1667 6.24998 14.1667C5.32952 14.1667 4.58331 14.9129 4.58331 15.8333C4.58331 16.7538 5.32952 17.5 6.24998 17.5Z"
      fill="#474A53"
      fillRule="evenodd"
    />
    <path
      d="M15.4166 4.16667C15.4166 5.08712 14.6704 5.83333 13.75 5.83333C12.8295 5.83333 12.0833 5.08712 12.0833 4.16667C12.0833 3.24619 12.8295 2.5 13.75 2.5C14.6704 2.5 15.4166 3.24619 15.4166 4.16667ZM13.75 11.6667C14.6704 11.6667 15.4166 10.9205 15.4166 10C15.4166 9.07954 14.6704 8.33333 13.75 8.33333C12.8295 8.33333 12.0833 9.07954 12.0833 10C12.0833 10.9205 12.8295 11.6667 13.75 11.6667ZM13.75 17.5C14.6704 17.5 15.4166 16.7538 15.4166 15.8333C15.4166 14.9129 14.6704 14.1667 13.75 14.1667C12.8295 14.1667 12.0833 14.9129 12.0833 15.8333C12.0833 16.7538 12.8295 17.5 13.75 17.5Z"
      fill="#474A53"
      fillRule="evenodd"
    />
  </svg>
)
